export default __webpack_public_path__ + "static/media/Dictatus Carver.8c227775.jpg";